import MTownSig1 from '../MTown Signature/Mtown Signature (1).webp'
import MTownSig2 from '../MTown Signature/Mtown Signature (2).webp'
import MTownSig3 from '../MTown Signature/Mtown Signature (3).webp'
import MTownSig4 from '../MTown Signature/Mtown Signature (4).webp'
import MTownSig5 from '../MTown Signature/Mtown Signature (5).webp'

const MTownSigimages =[
MTownSig1,MTownSig2,MTownSig3,MTownSig4,MTownSig5
]

export default MTownSigimages;